import { ROUTE_NAMES } from '../../../router/RouterApp';
import { FieldEventDataProps } from '@flos/react-components';
import { ITextFieldData } from '../../../common/interface/IAppProvider';
import { MutableRefObject } from 'react';
import smoothscroll from 'smoothscroll-polyfill';

export function getCurrentStep(routeName: ROUTE_NAMES): number {
    return Object.values(ROUTE_NAMES).indexOf(routeName) + 1;
}

export function getStepCount(): number {
    return Object.keys(ROUTE_NAMES).length;
}

export const IGNORED_INSURANCE_COMPANIES = [
    '9244020', // id of 'Ej Oplyst'
    '8764547' // id of 'Topdanmark'
];

export const defaults = (val: string): ITextFieldData => {
    return { value: val, status: 'valid', event: 'none' };
};

export function getContactUsURL() {
    const siteConfig = window.topContext.config.getSiteConfig();
    const originalHost = siteConfig.originalHost || 'www.topdanmark.dk';
    return `https://${originalHost}/faa-hjaelp/kontakt-os/`;
}

export function getHouseNumber(address: FieldEventDataProps): string {
    const floor = address.addressInfo.floor ?? '';
    const door = address.addressInfo.door ?? '';
    const streetName = address.addressInfo.streetName ?? '';
    const houseNumber = address.addressInfo.houseNumber ?? '';
    return `${streetName} ${houseNumber} ${floor} ${door}`.trim();
}

export function getPostCodeAndName(address: FieldEventDataProps): string {
    const supCityName = address.addressInfo.supCityName ?? '';
    const zipCode = address.addressInfo.zipCode ?? '';
    const postalCodeName = address.addressInfo.postalCodeName ?? '';
    return `${supCityName} ${zipCode} ${postalCodeName}`.trim();
}

export function createMarkup(string: string) {
    return { __html: string };
}

/**
 * PAJ - Scroll to a absolute Y axis postion in window
 * @param offset number - offset by a number
 */
export const scrollToWindowYPosition = (offset: number) => {
    window.scrollTo({
        top: offset,
        behavior: 'smooth'
    });
};

export const scrollToSection = (sectionRef: MutableRefObject<any>) => {
    if (!sectionRef) return;

    smoothscroll.polyfill();
    if (browser() === 'safari') {
        window.scrollTo({
            top: sectionRef.current.offsetTop - 60,
            left: 0,
            behavior: 'smooth'
        });
    } else {
        if (typeof sectionRef.current.firstElementChild.scrollIntoView === 'function') {
            sectionRef.current.firstElementChild.scrollIntoView({
                behavior: 'smooth'
            });
        }
    }
};

export const browser = () => {
    let userAgent = navigator.userAgent;
    let browserName;

    if (userAgent.match(/chrome|chromium|crios/i)) {
        browserName = 'chrome';
    } else if (userAgent.match(/firefox|fxios/i)) {
        browserName = 'firefox';
    } else if (userAgent.match(/safari/i)) {
        browserName = 'safari';
    } else if (userAgent.match(/opr\//i)) {
        browserName = 'opera';
    } else if (userAgent.match(/edg/i)) {
        browserName = 'edge';
    } else {
        browserName = 'No browser detection';
    }
    return browserName;
};
